module.exports = __webpack_public_path__ + "img/review-grid.4e0c36be.png";